import { Breadcrumb, Button, Card, Col, Empty, Form, Input, message, Row } from 'antd';
import { WrappedFormUtils } from 'antd/lib/form/Form';
import FormItem from 'antd/lib/form/FormItem';
import gql from 'graphql-tag';
import React, { Component, FormEvent } from 'react';
import { Query } from 'react-apollo';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

import { RedeemCodeTableList, TableType } from './RedeemCodeTableList';

export const ExpiredStatus = styled.span`
  color: #00000066;
`;
export const UsedStatus = styled.span`
  color: #e8080866;
`;

export const REDEEM_CODE_FIELDS = gql`
  fragment redeemCodeFields on RedeemCode {
    id
    code
    createdAt
    invalidAt
    template {
      id
      desc
      channel
      duration
    }
    redeemRecords {
      id
      userId
      invoiceId
      createdAt
      type
      user {
        id
        name
        mobile
      }
    }
  }
`;

export const REDEEM_CODES_QUERY = gql`
  ${REDEEM_CODE_FIELDS}
  query FindRedeemCodes($code: String, $mobile: String, $pagination: Pagination) {
    redeemCodes(code: $code, mobile: $mobile, pagination: $pagination) {
      ...redeemCodeFields
    }
  }
`;

interface Props {
  match: any;
  form: WrappedFormUtils;
}

interface State {
  variables: {
    code?: string;
    channel?: string;
    mobile?: string;
  };
  pagination: {
    take: number;
    skip?: number;
  };
  redeemCodeId?: number;
}

export class RedeemCodeListForm extends Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      variables: {},
      pagination: {
        take: 100,
        skip: 0,
      },
    };
    this.onResetClick = this.onResetClick.bind(this);
  }

  search = (e: FormEvent) => {
    this.props.form.validateFields(async (err, values) => {
      if (err) {
        message.error(err);
        return;
      }
      this.setState({
        variables: {
          code: values.code,
          mobile: values.mobile,
          channel: '',
        },
      });
    });

    e.preventDefault();
  };

  onResetClick() {
    this.props.form.resetFields();
  }

  render() {
    const { pagination } = this.state;
    const { getFieldDecorator } = this.props.form;
    return (
      <>
        <Breadcrumb style={{ marginBottom: 10, fontSize: 13 }}>
          <Breadcrumb.Item>
            <Link to={`/Home`}>首页</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>兑换码管理</Breadcrumb.Item>
        </Breadcrumb>
        <Query
          query={REDEEM_CODES_QUERY}
          variables={{ ...this.state.variables, pagination }}
          fetchPolicy="cache-and-network"
        >
          {({ loading, error, data }) => {
            if (error) return <div>{error.message}</div>;
            if (loading) return <div>loading.......</div>;
            if (!data) {
              // @ts-ignore
              return <Empty />;
            }

            const redeemCodes = (data && data.redeemCodes) || [];
            return (
              <Card>
                <Form onSubmit={this.search} style={{ marginBottom: 10 }}>
                  <Row gutter={24}>
                    <Col xs={24} md={12} lg={9} xl={7} xxl={5}>
                      <FormItem label="兑换码">
                        {getFieldDecorator('code')(<Input placeholder="请输入兑换码" allowClear />)}
                      </FormItem>
                    </Col>
                    <Col xs={24} md={12} lg={9} xl={7} xxl={5}>
                      <FormItem label="手机号">
                        {getFieldDecorator('mobile')(<Input placeholder="请输入手机号后四位" allowClear />)}
                      </FormItem>
                    </Col>
                  </Row>
                  <Row type="flex" justify="end" style={{ marginTop: 10 }}>
                    <Button style={{ marginRight: 8 }} type="primary" onClick={this.onResetClick}>
                      重置
                    </Button>
                    <Button icon="search" type="primary" htmlType="submit">
                      搜索
                    </Button>
                  </Row>
                </Form>

                <RedeemCodeTableList
                  redeemCodes={redeemCodes}
                  tabelListType={TableType.REDEEMCODE}
                  refetchQueries={[{ query: REDEEM_CODES_QUERY, variables: { ...this.state.variables, pagination } }]}
                />
              </Card>
            );
          }}
        </Query>
      </>
    );
  }
}

export const RedeemCodeList = Form.create({ name: 'RedeemCodeList' })(RedeemCodeListForm);



// WEBPACK FOOTER //
// ./src/screens/redeemCode/RedeemCodeList.tsx